import {
  DownloadOutlined,
  MailOutlined,
  DollarOutlined,
  CloseCircleOutlined,
  FileTextOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
} from "antd";
import { PDFDownloadLink } from "@react-pdf/renderer";
import React from "react";
import { useAuthContext } from "../../providers/AuthProvider";
import HotelDoc from "../../PdfDocuments/Hotel/HotelDoc";
import HotelInvoiceDoc from "../../PdfDocuments/Hotel/HotelInvoice";
import PayGateway from "../../../helpers/PayGateway";
import PayMentSelection from "../../PaymentSelection/PaymentSelection";
import PanVerification from "../../../pages/Hotels/HotelCheckout/PanVerification";
import {
  getEffectiveHotelBookingStatus,
  getHotelDownloadTicketHeader,
  shouldShowHotelTicketSidebar,
} from "./hotelhelper";
import "./HotelTicketScreen.scss";

const hotelModalCloseIcon = (
  <CloseOutlined className="hotel-ticket-modal__close-icon" />
);

const { Panel } = Collapse;

const HotelDownloadPdfButton = ({ loading, label }) => (
  <Button className="mb-1 hotel-ticket-download-btn" disabled={loading}>
    {label}
  </Button>
);

const HotelTicketDownloadPanel = React.memo(function HotelTicketDownloadPanel({
  ticketData,
  cmsFareRules,
  logoImage,
}) {
  const [activeKey, setActiveKey] = React.useState([]);

  return (
    <div className="mb-3 hotel-ticket-sidebar-download">
      <Collapse
        activeKey={activeKey}
        onChange={(keys) =>
          setActiveKey(Array.isArray(keys) ? keys : keys ? [keys] : [])
        }
        animated={false}
        destroyInactivePanel={false}
        expandIcon={() => <DownloadOutlined style={{ color: "#3d96ee" }} />}
        expandIconPosition="right"
      >
        <Panel
          header={
            <span style={{ color: "#3d96ee" }}>
              {getHotelDownloadTicketHeader(ticketData)}
            </span>
          }
          key="1"
        >
          <div className="trip-type-selector hotel-ticket-download-options">
            <PDFDownloadLink
              document={
                <HotelDoc
                  ticketData={ticketData}
                  cmsFareRules={cmsFareRules}
                  withFare={true}
                  Logo={logoImage}
                />
              }
              fileName="hotelTicket.pdf"
            >
              {({ loading }) => (
                <HotelDownloadPdfButton loading={loading} label="With Fare" />
              )}
            </PDFDownloadLink>

            <PDFDownloadLink
              document={
                <HotelDoc
                  ticketData={ticketData}
                  cmsFareRules={cmsFareRules}
                  withFare={false}
                  Logo={logoImage}
                />
              }
              fileName="hotelTicket.pdf"
            >
              {({ loading }) => (
                <HotelDownloadPdfButton loading={loading} label="Without Fare" />
              )}
            </PDFDownloadLink>
          </div>
        </Panel>
      </Collapse>
    </div>
  );
});

const HotelTicketEmailPanel = React.memo(function HotelTicketEmailPanel({
  onEmailWithPrice,
  onEmailWithoutPrice,
}) {
  const [activeKey, setActiveKey] = React.useState([]);

  return (
    <div className="mb-3 hotel-ticket-sidebar-email">
      <Collapse
        activeKey={activeKey}
        onChange={(keys) =>
          setActiveKey(Array.isArray(keys) ? keys : keys ? [keys] : [])
        }
        animated={false}
        destroyInactivePanel={false}
        expandIcon={() => <MailOutlined style={{ color: "#3d96ee" }} />}
        expandIconPosition="right"
      >
        <Panel header={<span style={{ color: "#3d96ee" }}>Email</span>} key="1">
          <div className="trip-type-selector hotel-ticket-email-options">
            <Button
              block
              className="hotel-ticket-email-btn"
              style={{ marginBottom: 10 }}
              onClick={onEmailWithPrice}
            >
              With Fare
            </Button>

            <Button block className="hotel-ticket-email-btn" onClick={onEmailWithoutPrice}>
              Without Fare
            </Button>
          </div>
        </Panel>
      </Collapse>
    </div>
  );
});

const HotelInvoiceDownload = React.memo(function HotelInvoiceDownload({
  invoiceData,
  invoiceLogo,
  type,
  label,
}) {
  const document = React.useMemo(
    () => (
      <HotelInvoiceDoc
        invoiceData={invoiceData}
        logo={invoiceLogo}
        type={type}
      />
    ),
    [invoiceData, invoiceLogo, type],
  );

  return (
    <div
      className="ticket-options"
      style={{ backgroundColor: "#f1f8ff", marginTop: "1rem" }}
    >
      <p>
        <PDFDownloadLink document={document} fileName="Hotel_Invoice.pdf">
          {() => (
            <Button className="invoice-btn border-0">
              <strong style={{ color: "#3d96ee" }}>{label}</strong>
              <FileTextOutlined
                style={{ marginLeft: "110px", color: "#3d96ee" }}
              />
            </Button>
          )}
        </PDFDownloadLink>
      </p>
    </div>
  );
});

const HotelTicketSidebar = ({
  ticketData,
  invoiceData = {},
  cmsFareRules = {},
  logoImage,
  invoiceLogo = null,
  ticketMode,
  toggleEmailModal = () => {},
  setWithFare = () => {},
  handleCancel = () => {},
  togglePstMrkModal = () => {},
  pstMrkModalVisible,
  pstMrkForm,
  submitPostMarkup = () => {},
  toggleRemoveMrkModal = () => {},
  removeMrkModalVisible,
  removeMrkForm,
  submitRemovePostMarkup = () => {},
  emailModalVisible,
  emailForm,
  submitEmailForm = () => {},
  toggleEmailModalClose = () => {},
  pgData = { visible: false },
  blockApiReq = () => {},
  collapseHotelVoucherPayment = () => {},
  contextOnPaymentModeSelection = () => {},
  SeletedPayOption,
  setValue,
  value,
  Deposit = false,
  setPanModalVisible = () => {},
  confirmHotelBooking = () => {},
  panModalVisible,
  togglePanModal = () => {},
  panVerified,
  verifiedPan,
  panModalError,
  panAddLoading,
  handleAddPan = () => {},
  handlePanVerificationResult = () => {},
  handlePanVerifyError = () => {},
  setPanModalError = () => {},
  handleGenerateHotelVoucher = () => {},
  samePanForAllRooms = false,
}) => {
  const {
    isLogin: { agent },
  } = useAuthContext();

  const effectiveStatus = getEffectiveHotelBookingStatus(ticketData);
  const isCancelled = [6, 12].includes(effectiveStatus);

  const showCancelHotel =
    (effectiveStatus == 3 ||
      effectiveStatus == 10 ||
      effectiveStatus == 11) &&
    // Tripjack API shows Cancel even for Non-refundable — allow attempt;
    // refund may be 0 / full charges. Only hide after cancelled.
    ticketData?.cancellable !== false;

  const showGenerateVoucher =
    ticketMode !== "ADMIN" &&
    ticketData?.BookingStatus === 10 &&
    ticketData?.PurchaseType === "Block";

  const showInvoice =
    agent && [3, 11].includes(Number(invoiceData?.BookingStatus));

  const showCreditNote =
    agent && [6, 12].includes(invoiceData.BookingStatus);

  const handleEmailWithPrice = React.useCallback(() => {
    toggleEmailModal();
    setWithFare(1);
  }, [toggleEmailModal, setWithFare]);

  const handleEmailWithoutPrice = React.useCallback(() => {
    toggleEmailModal();
    setWithFare(0);
  }, [toggleEmailModal, setWithFare]);

  if (isCancelled) {
    return null;
  }

  if (!shouldShowHotelTicketSidebar(ticketData)) {
    return null;
  }

  return (
    <>
    <div className="actionable-buttons hotel-ticket-sidebar-actions">
      <HotelTicketDownloadPanel
        ticketData={ticketData}
        cmsFareRules={cmsFareRules}
        logoImage={logoImage}
      />

      <HotelTicketEmailPanel
        onEmailWithPrice={handleEmailWithPrice}
        onEmailWithoutPrice={handleEmailWithoutPrice}
      />

      {showCancelHotel ? (
        <div
          className="ticket-options"
          style={{ backgroundColor: "#ffdbdb" }}
        >
          <p
            onClick={() => handleCancel("Hotel")}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#ef6d71",
              marginRight: "5px",
              paddingLeft: "15px",
              cursor: "pointer",
            }}
          >
            Cancel <CloseCircleOutlined />
          </p>
        </div>
      ) : null}

      {showGenerateVoucher ? (
        <div className="ticket-options">
          {pgData.visible ? (
            <>
              <PayGateway
                blockApiReq={blockApiReq}
                IsDeposit={Deposit}
                OnPaymentModeSelection={contextOnPaymentModeSelection}
                collapsiblePaymentLabel
                onPaymentLabelClick={collapseHotelVoucherPayment}
              />
              {SeletedPayOption ? (
                <div className="mb-3">
                  <PayMentSelection setValue={setValue} value={value} />
                </div>
              ) : null}
            </>
          ) : (
            <p
              onClick={() => {
                handleGenerateHotelVoucher();
              }}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#EE4B2B",
                marginRight: "5px",
                paddingLeft: "15px",
                cursor: "pointer",
              }}
            >
              Generate Voucher <DollarOutlined />
            </p>
          )}
        </div>
      ) : null}

      {agent ? (
        <>
          <div
            className="ticket-options"
            style={{ backgroundColor: "#f1f8ff" }}
          >
            <p
              onClick={() => togglePstMrkModal()}
              style={{
                backgroundColor: "#f1f8ff",
                color: "#2f8fed",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingLeft: "15px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Add Markup <DollarOutlined style={{ marginRight: "12px" }} />
            </p>
          </div>

          <div
            className="ticket-options"
            style={{ backgroundColor: "#f1f8ff" }}
          >
            <p
              onClick={() => toggleRemoveMrkModal()}
              style={{
                backgroundColor: "#f1f8ff",
                color: "#2f8fed",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingLeft: "15px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Remove Markup <DollarOutlined style={{ marginRight: "12px" }} />
            </p>
          </div>

          {showInvoice ? (
            <HotelInvoiceDownload
              invoiceData={invoiceData}
              invoiceLogo={invoiceLogo}
              type="invoice"
              label="Invoice"
            />
          ) : null}

          {showCreditNote ? (
            <HotelInvoiceDownload
              invoiceData={invoiceData}
              invoiceLogo={invoiceLogo}
              type="credit_note"
              label="Credit Note"
            />
          ) : null}
        </>
      ) : null}
    </div>

      {agent ? (
        <>
          <Modal
            title="Add Markup"
            width={250}
            className="promo-modal-header hotel-ticket-modal"
            closeIcon={hotelModalCloseIcon}
            visible={pstMrkModalVisible}
            onOk={togglePstMrkModal}
            onCancel={togglePstMrkModal}
            footer={[
              <div key="footer">
                <Button key="close" onClick={togglePstMrkModal}>
                  Cancel
                </Button>

                <Button
                  key="add"
                  type="primary"
                  htmlType="submit"
                  onClick={pstMrkForm.submit}
                >
                  Add
                </Button>
              </div>,
            ]}
          >
            <Form
              form={pstMrkForm}
              layout="vertical"
              onFinish={submitPostMarkup}
            >
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Amount"
                    name="amount"
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                      {
                        validator: (_, val) => {
                          if (Number(val) > 0) {
                            return Promise.resolve();
                          }
                          return Promise.reject("Please Enter valid Amount");
                        },
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} type="number" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>

          <Modal
            title="Remove Markup"
            width={250}
            className="promo-modal-header hotel-ticket-modal"
            closeIcon={hotelModalCloseIcon}
            visible={removeMrkModalVisible}
            onOk={toggleRemoveMrkModal}
            onCancel={toggleRemoveMrkModal}
            footer={[
              <div key="footer">
                <Button key="close" onClick={toggleRemoveMrkModal}>
                  Cancel
                </Button>

                <Button
                  key="remove"
                  type="primary"
                  htmlType="submit"
                  onClick={removeMrkForm?.submit}
                >
                  Remove
                </Button>
              </div>,
            ]}
          >
            <Form
              form={removeMrkForm}
              layout="vertical"
              onFinish={submitRemovePostMarkup}
            >
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Amount"
                    name="amount"
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                      {
                        validator: (_, val) => {
                          if (Number(val) > 0) {
                            return Promise.resolve();
                          }
                          return Promise.reject("Please Enter valid Amount");
                        },
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} type="number" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>

          <Modal
            title="Enter PAN Number"
            className="promo-modal-header hotel-ticket-modal hotel-pan-modal"
            closeIcon={hotelModalCloseIcon}
            visible={panModalVisible}
            onCancel={togglePanModal}
            footer={[
              <Button key="cancel" onClick={togglePanModal}>
                Cancel
              </Button>,
              <Button
                key="add"
                type="primary"
                disabled={!panVerified || panAddLoading}
                loading={panAddLoading}
                onClick={handleAddPan}
              >
                Add
              </Button>,
            ]}
          >
            <div className="hotel-pan-modal__content">
            <PanVerification
              setPanVerificationNumber={handlePanVerificationResult}
              onVerifyError={handlePanVerifyError}
              onVerifyStart={() => setPanModalError("")}
              showInlineErrors
            />
            {panVerified ? (
              <p style={{ color: "green", marginTop: "10px" }}>
                ✅ PAN Verified: <strong>{verifiedPan}</strong>
              </p>
            ) : !panModalError ? (
              <p style={{ color: "gray", marginTop: "10px" }}>
                Please click <strong>Apply</strong> to verify your PAN number.
              </p>
            ) : null}
            {panModalError ? (
              <p
                style={{ color: "#cf1322", marginTop: "10px", fontWeight: 600 }}
              >
                {panModalError}
              </p>
            ) : null}
            </div>
          </Modal>
        </>
      ) : null}

      <Modal
        title="Enter The Email Address"
        className="promo-modal-header hotel-ticket-modal"
        closeIcon={hotelModalCloseIcon}
        visible={emailModalVisible}
        onOk={toggleEmailModalClose}
        onCancel={toggleEmailModalClose}
        footer={[
          <div key="footer">
            <Button key="close" onClick={toggleEmailModalClose}>
              Cancel
            </Button>

            <Button
              key="add"
              type="primary"
              htmlType="submit"
              onClick={emailForm.submit}
            >
              Send
            </Button>
          </div>,
        ]}
      >
        <Form form={emailForm} layout="vertical" onFinish={submitEmailForm}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Email"
                name="Email"
                rules={[
                  { required: true, message: "Required!" },
                  { type: "email", message: "Email is not a valid email" },
                ]}
              >
                <Input placeholder="Enter The Email Address" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default HotelTicketSidebar;
